<template>
  <div class="distribution-levels-component" :class="{first:step===1, last, 'editor-view':localModel.edit_mode}">
    <v-row class="flex-nowrap align-center ma-0">
      <v-col class="py-0 step-col" cols="auto">
        <div class="step d-flex align-center justify-center">
          <div class="step-content">
            {{$t('marketplaceAdministration.step')}} {{ step }}
          </div>
        </div>
      </v-col>
      <v-col class="col-content py-0">
        <v-row>
          <v-col class="flex-grow-1 py-0">
            <v-row>
              <v-col class="col-step-strategy py-0">
                <span class="caption">{{$t('marketplaceAdministration.strategy')}}</span>
                <span class="label font-weight-medium" v-if="!localModel.edit_mode">{{ strategyTextComputed }}</span>
                <div class="edit-group" v-if="localModel.edit_mode">
                  <v-select
                    :items="strategyOptions"
                    v-model="localModel.strategy"
                    label="Intervall"
                    outlined
                    class="pr-1"
                  />
                  <ToolTip>
                    <template v-slot:title>
                      Tooltip Title
                    </template>
                    <p>
                      Dies ist ein Typoblindtext. An ihm kann man sehen, ob alle Buchstaben da sind und wie sie aussehen.
                    </p>
                    <p>
                      Manchmal benutzt man Worte wie Hamburgefonts, Rafgenduks oder Handgloves, um Schriften zu testen.
                      Manchmal Sätze, die alle Buchstaben des Alphabets enthalten - man nennt diese Sätze »Pangrams«. Sehr
                      bekannt ist dieser: The
                    </p>
                  </ToolTip>
                </div>
              </v-col>
              <v-col class="col-step-time py-0">
                <span class="caption">{{$t('marketplaceAdministration.escalationPeriod')}}</span>
                <span class="label font-weight-medium" v-if="!localModel.edit_mode">{{ formatDate(localModel.time) }}</span>
                <div class="edit-group" v-if="localModel.edit_mode">
                  <DurationInput class="label-input" :limits="'99:24:60'" :format="'DHM'" v-model="localModel.time"/>
                  <ToolTip>
                    <template v-slot:title>
                      Tooltip Title
                    </template>
                    <p>
                      Dies ist ein Typoblindtext. An ihm kann man sehen, ob alle Buchstaben da sind und wie sie aussehen.
                    </p>
                    <p>
                      Manchmal benutzt man Worte wie Hamburgefonts, Rafgenduks oder Handgloves, um Schriften zu testen.
                      Manchmal Sätze, die alle Buchstaben des Alphabets enthalten - man nennt diese Sätze »Pangrams«. Sehr
                      bekannt ist dieser: The
                    </p>
                  </ToolTip>
                </div>
              </v-col>
              <v-col class="col-step-strategy-detail py-0">
                <slot :name="localModel.strategy" v-bind:step="localModel"></slot>
              </v-col>
            </v-row>
          </v-col>
          <v-col class="col-edit-mode-buttons d-flex">
            <div class="edit-mode-buttons with-placeholder" v-if="!localModel.edit_mode">
              <v-btn @click="onEdit" icon>
                <EditIcon/>
              </v-btn>
            </div>
            <div class="edit-mode-buttons mt-auto" v-if="localModel.edit_mode">
                <v-btn @click="onSave" icon>
                  <AcceptIcon/>
                </v-btn>
                <v-btn @click="onDiscard" icon>
                  <DiscardIcon/>
                </v-btn>
                <v-btn @click="onDelete" icon>
                  <DeleteIconLight/>
                </v-btn>
              </div>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import {ref, watch, computed, toRefs} from '@vue/composition-api'
import EditIcon from "@/components/icons/Edit2Icon";
import AcceptIcon from "@/components/icons/AcceptIcon";
import DiscardIcon from "@/components/icons/DiscardIcon";
import DeleteIconLight from "@/components/icons/DeleteIconLight";
import ToolTip from "@/components/info/ToolTip";
import DurationInput from "@/components/form/DurationInput";

export default {

  name: 'DistributionLevelEditorItemComponent',
  components: {
    DurationInput,
    EditIcon,
    AcceptIcon,
    DiscardIcon,
    DeleteIconLight,
    ToolTip
  },
  props: {
    value: {
      type: Object,
      default: () => {
        return {}
      }
    },
    strategyOptions: {
      type: Array,
      default: () => []
    },
    step: {
      type: Number,
      default: 0
    },
    last: {
      type: Boolean,
      default: false
    }
  },
  setup(props, {emit}) {

    // local state
    const localModel = ref({})
    resetLocalModel()
    let watched = Object.values(toRefs(props.value))
    watched = [...watched, () => props.value]
    watch(
      watched,
      () => {
        resetLocalModel()
      },
      {deep: true}
    )

    function deleteProperties(object){
      for (let variableKey in object){
        // eslint-disable-next-line no-prototype-builtins
        if (object.hasOwnProperty(variableKey)){
          delete object[variableKey];
        }
      }
      return object
    }

    function resetLocalModel() {
      localModel.value = Object.assign({}, {
        ...props.value,
        edit_mode: typeof props.value.edit_mode !== 'undefined' ?
          props.value.edit_mode :
          typeof localModel.value.edit_mode !== 'undefined' ?
            localModel.value.edit_mode :
            false,
        settings: typeof localModel.value.settings === 'undefined' ?
          typeof props.value.settings === 'undefined' ?
            {} :
            Object.assign({}, props.value.settings)
          :
          typeof props.value.settings === 'undefined' ?
            deleteProperties(localModel.value.settings) :
            Object.assign(localModel.value.settings, props.value.settings)
      })
    }

    const strategyTextComputed = computed(() => {
      for (let i = 0; i < props.strategyOptions.length; i++) {
        if (props.strategyOptions[i].value === localModel.value.strategy) {
          return props.strategyOptions[i].text
        }
      }
      return ''
    })

    function onDiscard() {
      localModel.value.edit_mode = false
      if (localModel.value.strategy === '') {
        onDelete()
      } else {
        resetLocalModel()
      }
    }

    function onSave() {
      if(localModel.value.strategy !== '') {
        localModel.value.edit_mode = false
        emit('input', Object.assign({}, {...localModel.value, settings: Object.assign({}, localModel.value.settings)}))
      }
    }

    function onDelete() {
      localModel.value.edit_mode = false
      emit('deleted')
    }

    function onEdit() {
      localModel.value.edit_mode = true
    }

    function formatDate(dateString){
      let split = dateString.split(':')
      return `${split[0]}D:${split[1]}H:${split[2]}M`
    }

    return {localModel, strategyTextComputed, onDiscard, onSave, onDelete, onEdit, formatDate};
  }
}
</script>

<style lang="scss" scoped>
.distribution-levels-component {
  position: relative;
  padding: $spacer/2 0 $spacer - 4px;

  // Editing styling
  &.editor-view {
    position: relative;
    padding-top: $spacer*1.5;
    padding-bottom: $spacer*1.5;

    &:before,
    &:after {
      position: absolute;
      border-bottom: 1px dashed map-get($green, 'darken-1');
      content: '';
      display: block;
      width: 100%;
      height: 1px;
    }

    &:before {
      top: 8px;
    }

    &:after {
      bottom: 8px;
    }

    &.first {
      padding-top: $spacer/2;

      &:before {
        display: none;
      }
    }

    &.last {
      padding-bottom: $spacer/2;

      &:after {
        display: none;
      }
    }

    .step-col .step {
      border-color: map-get($green, 'darken-1');

      .step-content {
        border-bottom: 1px solid map-get($green, 'darken-1');
        color: map-get($green, 'darken-1');
      }
    }
  }

  // Step line
  &.first {
    .step-col::before {
      display: none;
    }
  }

  &.last {
    border-bottom: none;

    .step-col::after {
      display: none;
    }
  }

  // Steps
  .step-col {
    flex: 0 0 172px;
    max-width: 172px;

    // Vertical lines
    &::before,
    &::after {
      position: absolute;
      z-index: 1;
      background-color: map-get($grey, 'lighten-blue-1');
      content: '';
      display: block;
      width: 1px;
      height: calc(50% + 16px);
    }

    &::before {
      top: -2px;
    }

    &::after {
      bottom: -2px;
    }

    .step {
      position: relative;
      z-index: 2;
      background-color: white;
      box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);
      border: 2px solid map-get($grey, 'lighten-blue-1');
      border-radius: 5px;
      padding: $spacer/2;
      width: 140px;
      height: 100%;
      min-height: 140px;
      display: flex;

      .step-content {
        border-bottom: 1px solid map-get($grey, 'lighten-blue-1');
        color: map-get($grey, 'lighten-blue-1');
        font-size: 18px;
        line-height: 20px;
        text-align: center;
        margin: auto;
        width: 100%;
        max-width: 110px;
      }
    }
  }

  // Edit grup
  .edit-group {
    position: relative;
    display: flex;
    margin-bottom: $spacer*.75;
    padding-top: 4px;

    .tooltip {
      position: absolute;
      top: -8px;
      right: -24px;
    }
  }

  // Content
  .caption {
    display: block;
    color: map-get($grey, 'darken-1');
    font-size: 14px !important;
    line-height: 17px;
    margin-bottom: $spacer/4;
  }

  .label {
    display: block;
    font-size: 16px;
    line-height: 20px;
    margin-bottom: $spacer/2;
  }

  // Time label styling
  .col-step-time {
    .label {
      letter-spacing: 0.25em;
    }
  }

  // Col steps responsive width setting
  .col-step-strategy,
  .col-step-strategy-detail,
  .col-step-time {
    flex: 0 0 100%;
    width: 100%;

    @media screen and (max-width: 1739px) {
      padding-right: $spacer*2;
    }

    @media screen and (min-width: 1740px) {
      flex: 1 0 180px;
      min-width: 180px;
      max-width: 50%;
    }
  }

  // Button group
  .col-edit-mode-buttons {
    padding-top: 8px;
    padding-right: 16px;
    padding-bottom: 8px;
    flex: 0 0 160px;
    max-width: 160px;
  }

  .edit-mode-buttons {
    margin-bottom: 8px;
    flex: 0 0 160px;
    width: 160px;

    &.with-placeholder {
      margin-left: 50px;
    }

    button {
      background: transparent;
      box-shadow: none;
      padding: 8px 0;
      min-width: 0;

      @media screen and (min-width: 1200px) {
        padding: 8px;
      }

      &:before {
        display: none;
      }

      &:hover {
        svg {
          .a, .b {
            stroke: #73998E;
          }
        }
      }

      + button {
        margin-left: 12px;
      }

      .v-ripple__container {
        display: none;
      }
    }
  }

  // Edit view
  &.editor-view {

    // Change circle color
    .step-col .step {
      border-color: map-get($green, 'darken-1');
    }

    // Change position of button group
    .edit-mode-buttons {
      position: absolute;
      right: 0;
      bottom: $spacer*1.5;
    }
  }
}
</style>

<!-- icons and other external components -->
<style lang="scss">
.distribution-levels-component {
  .step-col {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .edit-group {
    // Remove label form select item
    .v-text-field {
      .v-label {
        display: none;
      }

      &--outlined legend {
        display: none;
      }
    }
  }
}
</style>



